import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import WebFont from 'webfontloader';
import "./i18nextInit";

// Css
//import "bootstrap/dist/css/bootstrap.min.css";
//import 'bootstrap/dist/js/bootstrap.bundle.min';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import "../node_modules/slick-carousel/slick/slick.css"; 
import "../node_modules/slick-carousel/slick/slick.css";
import '../node_modules/magnific-popup/dist/magnific-popup.css';
import "../node_modules/react-datepicker/dist/react-datepicker.css";
import './assets/css/animate.min.css';
import './assets/css/font-awesome.min.css';
import './assets/css/flaticon.css';
import './assets/css/default.css';
import './index.css';
import './indexcss.js'

WebFont.load({
  google: {
    families: ['Roboto', 'sans-serif','Playfair Display', 'Titillium Web', 'Roboto condensed', 'Bebas Neue', 'Oswald']
  }
});

ReactDOM.render(
  <BrowserRouter>
    <Suspense fallback="loading">
      <App />
    </Suspense>
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
